import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { successLoader } from 'router/loaders/success';
import {
  hasUserSubmittedPricingStep,
  leadHasTaxId,
} from 'router/loaders/utils/validation';
import { isVerified } from 'services/partnersSelfSignup/otp';
import { signupSearchParams } from 'router/search/signup';
import { beforeLoadSignupSubRoute, headSignupSubRoute } from 'router/utils';
import { validateSuccessPageAccess } from 'router/validateLeadStatus';

export const Route = createFileRoute('/_signup/success')({
  validateSearch: zodValidator(signupSearchParams),
  head: headSignupSubRoute,
  beforeLoad: ({ context, location, preload, cause }) =>
    beforeLoadSignupSubRoute({
      context,
      location,
      preload,
      cause,
      validateLeadStatus: validateSuccessPageAccess,
      validation: {
        validate: async ({ lead }) => {
          const { queryClient } = context;
          if (
            !leadHasTaxId(lead) ||
            !hasUserSubmittedPricingStep(lead) ||
            !(await isVerified({
              queryClient,
              email: lead.businessEmail ?? '',
            }))
          ) {
            throw redirect({ to: '/gym/tax-details' });
          }

          return true;
        },
      },
    }),
  loader: args => successLoader(args),
});
